import { render, staticRenderFns } from "./TypeOfBusiness.vue?vue&type=template&id=039a2d54"
import script from "./TypeOfBusiness.vue?vue&type=script&lang=js"
export * from "./TypeOfBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports